import React, { useState } from 'react';
import Modal from '@components/common/Modal';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import styles from './checksCart.module.scss';
import cn from 'classnames';
import { connect } from 'react-redux';

const CashPay = ({
  isOpen,
  onClose,
  cashPaymentCallBack,
  serverAppTheme
}) => {
  const [actionType, setActionType] = useState(() => {
    return 'disclamerMessage';
  });
  return (
      <Modal
        isOpen={isOpen}
        isModalCenter
        style={{ margin:'auto', backgroundColor:serverAppTheme?.popUp_bg, borderRadius:'16px',width: '488px', border:serverAppTheme?.popupBorder, boxShadow: serverAppTheme?.popUp_box_shadow}}
        noBackground
      >
        <div className="col-12 p-4 text-center fs-18" style={{color: serverAppTheme?.primary_text}}>
          {actionType === 'disclamerMessage' && (
            <div className="col-12 text-center p-0 row mx-0 justify-content-center align-items-center">
              <div className="w-100  text-center">{CUSTOM_MESSAGES().CASH_PAYMENT_PROCESSED_BY_SERVER}</div>
              <div className='col-10 row mt-3'>
              <div className="col-6 p-2">
                <button
                  type="submit"
                  className={cn(styles.btnSecondary, "col-12")}
                  onClick={() => onClose()}
                  style={{background: serverAppTheme?.OFF_Premise_Btn, border: serverAppTheme?.cancleBtn_Border, color: serverAppTheme?.cancleBtn_font}}
                >
                  {LABEL().NO}
                </button>
              </div>
              <div className="col-6 p-2">
                <button
                  type="submit"
                  className={cn(styles.btnPrimary, "col-12")} 
                  onClick={() => cashPaymentCallBack().then(() => setActionType('paymentComplete'))}
                  style={{background:serverAppTheme?.secondaryBtn, color:serverAppTheme?.btn_font_color}}
                >
                  {LABEL().YES}
                </button>
              </div>
              </div>
            </div>
           )}
          {actionType === 'paymentComplete' && (
            <div className="w-100 row mx-0 justify-content-center ">
              <div className="col-12 py-1 text-center">
                {CUSTOM_MESSAGES().GREAT_SERVING_YOU}
              </div>
              <div className="col-12 py-1 text-center">
                {CUSTOM_MESSAGES().COME_BACK_SOON}
              </div>
              <div className="col-6 p-0 h-25 d-flex justify-content-center align-items-end py-2">
                <button
                  type="submit"
                  className={cn(styles.btnPrimary, "col-6 m-2 ")} 
                  onClick={() => onClose()}
                  style={{background:serverAppTheme?.secondaryBtn, color:serverAppTheme?.btn_font_color}}
                >
                  {LABEL().CLOSE}
                </button>
              </div>
            </div>
          )}
        </div>
      </Modal>
  );
};
const mapStateToProps = ({ theme }) => ({
  serverAppTheme: theme.serverAppTheme,
});
export default connect(mapStateToProps)(CashPay);
